jQuery(document).ready(function($) {

  var position = $(window).scrollTop();

  $(window).scroll(function() {
      var scroll = $(window).scrollTop();
      if(scroll > position && scroll < 100) {
        $('.site-header').addClass('on-scroll-down');
        $('.site-header').removeClass('on-scroll-up');
    } else {
        $('.site-header').removeClass('on-scroll-down');
        $('.site-header').addClass('on-scroll-up');
        $('.site-header').removeClass('on-pin');
      }

      if(scroll < 100) {
        $('.site-header').removeClass('on-scroll-down');
        $('.site-header').removeClass('on-scroll-up');
      }

      if(scroll > position && scroll > 600) {
        $('.site-header').addClass('on-pin');
      }

      position = scroll;

  });
  
  var adminBar = $('#wpadminbar').outerHeight();
  $('.admin-bar').find('.site-header').css('top', adminBar);
  $(window).resize(function() {
     var adminBarResize = $('#wpadminbar').outerHeight();
     $('.admin-bar').find('.site-header').css('top', adminBarResize);
  });

  //Fixes news hero tucking under header
  var adminHeight = $('#wpadminbar').outerHeight();
  var headerHeight = $('.site-header').outerHeight();

  $('.site-header').css('top', adminHeight);
  $('.single-post .content-area').css('margin-top',headerHeight);

      // tabbed content
   // http://www.entheosweb.com/tutorials/css/tabs.asp
   //$(".tab_content").hide();
   $(".tab_content:first-of-type").show();

   $("ul.tabs > li:first-child").addClass("active");
   $(".tab_drawer_heading:first-of-type").addClass("d_active");

  


   /* if in tab mode */
     $("ul.tabs li").click(function() {
       $(this).parent().parent().find(".tab_content").hide();
       var activeTab = $(this).attr("rel");
       $(this).parent().parent().find("#"+activeTab).fadeIn();

       $(this).parent().parent().find("ul.tabs li").removeClass("active");
       $(this).addClass("active");

       $(".tab_drawer_heading").removeClass("d_active");
       $(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");
     });

     /* if in drawer mode */
     /* if in drawer mode */
     $(".tab_drawer_heading").click(function() {
          var d_activeTab = $(this).attr("rel");

          if ($(this).hasClass("d_active")) {

            $(this).parent().find("#"+d_activeTab).hide();
            $(this).removeClass("d_active");

          } else {

            $(this).addClass("d_active");
            $(this).parent().find(".tab_content").hide();
            $(this).parent().find("#"+d_activeTab).fadeIn();
            $(this).parent().find(".tab_drawer_heading").removeClass("d_active");
            $(this).addClass("d_active");
            $("ul.tabs li").removeClass("active");
            $("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");

          }
      });


      $('.sf-field-search input').click(function() {

        if (!$(this).parent().parent().hasClass("expand")) {
            $(this).parent().parent().addClass('expand');
            $(this).parent().parent().append('<div class="close-search" alt="close search"><i class="fa-regular fa-xmark-large"></i></div>');
          }

      });
      $(document).on('click','.close-search',function(){

        if ( $(this).parent().find('.sf-input-text').val() != '' ) {
            $(this).parent().find('.sf-input-text').val("");
            $(this).parent().parent().parent('.searchandfilter').submit();
        }
      
         $(this).parent().removeClass('expand');
        
         $(this).remove();
      

      });

      var listHeroHeight = $('.page-template-page-project-list .hero-area').outerHeight();
      var listFooterHeight = $('.page-template-page-project-list .site-footer').outerHeight();
      var listSearchHeight = $('.page-template-page-project-list .search-form').outerHeight();
      var listCalcHeight = listHeroHeight + listFooterHeight + listSearchHeight;

      $('.project-grid').css('min-height', "calc(100vh - " + listCalcHeight + "px)");
 
      if ($(this).width() <= 768) {
        $('.flex-content.image-with-text.white').next('.flex-content.white ').css('padding-top', '0px');
        $('.flex-content.image-with-text.black').next('.flex-content.black ').css('padding-top', '0px');        
        $('.flex-content.fifty-fifty.white').next('.flex-content.white ').css('padding-top', '0px');
        $('.flex-content.fifty-fifty.black').next('.flex-content.black ').css('padding-top', '0px');
        $('.flex-content.featured-project.white').next('.flex-content.white ').css('padding-top', '0px');
        $('.flex-content.featured-project.black').next('.flex-content.black ').css('padding-top', '0px');
        $('.flex-content.quote.white').next('.flex-content.white ').css('padding-top', '0px');
        $('.flex-content.quote.black').next('.flex-content.black ').css('padding-top', '0px');      
      }

      $(window).resize(function() {
          if ($(this).width() <= 768) {
              $('.flex-content.image-with-text.white').next('.flex-content.white ').css('padding-top', '0px');
              $('.flex-content.image-with-text.black').next('.flex-content.black ').css('padding-top', '0px');
              $('.flex-content.fifty-fifty.white').next('.flex-content.white ').css('padding-top', '0px');
              $('.flex-content.fifty-fifty.black').next('.flex-content.black ').css('padding-top', '0px');
              $('.flex-content.featured-project.white').next('.flex-content.white ').css('padding-top', '0px');
              $('.flex-content.featured-project.black').next('.flex-content.black ').css('padding-top', '0px');
                 $('.flex-content.quote.white').next('.flex-content.white ').css('padding-top', '0px');
        $('.flex-content.quote.black').next('.flex-content.black ').css('padding-top', '0px');   
          }
      });

      $('h4').addClass('headingFour');

    //Callout Accordions
    var width = $(window).width();
    if ($(window).outerWidth() > 0 && $(window).outerWidth() < 768) {
        function toggleAttr() {
            if ($('.expand-collapse').hasClass('active')) {
                $('.expand-collapse-content').attr('aria-hidden', false);
            } else {
                $('.expand-collapse-content').attr('aria-hidden', true);
            }
        }
    
        function toggleExpandCollapse() {
          $(this).toggleClass('active');
          $(this).next(".expand-collapse-content").slideToggle();
          toggleAttr();
          return false;
        }
        $('.expand-collapse-content').hide();
        $('.expand-collapse').on('click', toggleExpandCollapse);
    
        $('.callout-wrapper.auto-expand > .expand-collapse').toggleClass('active');
        $('.callout-wrapper.auto-expand > .expand-collapse').next(".expand-collapse-content").slideToggle();
    } else {
      $('.expand-collapse-content').show();
    }

    $(window).resize(function() {
      if ($(window).outerWidth() > 0 && $(window).outerWidth() < 768) {
        $('.expand-collapse-content').hide();
      } else {
        $('.expand-collapse-content').show();
      }
    });
});


